module.exports = __webpack_public_path__ + "img/icon-16-back-right-two.e3851aed.svg";